! function(t, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define([], n) : "object" == typeof exports ? exports.Scrollbar = n() : t.Scrollbar = n()
}(window, function() {
  return function(t) {
    var n = {};

    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports
    }
    return e.m = t, e.c = n, e.d = function(t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: r
      })
    }, e.r = function(t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      })
    }, e.t = function(t, n) {
      if (1 & n && (t = e(t)), 8 & n) return t;
      if (4 & n && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (e.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & n && "string" != typeof t)
        for (var o in t) e.d(r, o, function(n) {
          return t[n]
        }.bind(null, o));
      return r
    }, e.n = function(t) {
      var n = t && t.__esModule ? function() {
        return t.default
      } : function() {
        return t
      };
      return e.d(n, "a", n), n
    }, e.o = function(t, n) {
      return Object.prototype.hasOwnProperty.call(t, n)
    }, e.p = "", e(e.s = 58)
  }([function(t, n, e) {
    var r = e(25)("wks"),
      o = e(16),
      i = e(2).Symbol,
      u = "function" == typeof i;
    (t.exports = function(t) {
      return r[t] || (r[t] = u && i[t] || (u ? i : o)("Symbol." + t))
    }).store = r
  }, function(t, n) {
    t.exports = function(t) {
      return "object" == typeof t ? null !== t : "function" == typeof t
    }
  }, function(t, n) {
    var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = e)
  }, function(t, n) {
    var e = t.exports = {
      version: "2.6.5"
    };
    "number" == typeof __e && (__e = e)
  }, function(t, n, e) {
    var r = e(2),
      o = e(3),
      i = e(11),
      u = e(5),
      c = e(10),
      s = function(t, n, e) {
        var a, f, l, p, h = t & s.F,
          d = t & s.G,
          v = t & s.S,
          y = t & s.P,
          m = t & s.B,
          g = d ? r : v ? r[n] || (r[n] = {}) : (r[n] || {}).prototype,
          b = d ? o : o[n] || (o[n] = {}),
          x = b.prototype || (b.prototype = {});
        for (a in d && (e = n), e) l = ((f = !h && g && void 0 !== g[a]) ? g : e)[a], p = m && f ? c(l, r) : y && "function" == typeof l ? c(Function.call, l) : l, g && u(g, a, l, t & s.U), b[a] != l && i(b, a, p), y && x[a] != l && (x[a] = l)
      };
    r.core = o, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s
  }, function(t, n, e) {
    var r = e(2),
      o = e(11),
      i = e(9),
      u = e(16)("src"),
      c = e(60),
      s = ("" + c).split("toString");
    e(3).inspectSource = function(t) {
      return c.call(t)
    }, (t.exports = function(t, n, e, c) {
      var a = "function" == typeof e;
      a && (i(e, "name") || o(e, "name", n)), t[n] !== e && (a && (i(e, u) || o(e, u, t[n] ? "" + t[n] : s.join(String(n)))), t === r ? t[n] = e : c ? t[n] ? t[n] = e : o(t, n, e) : (delete t[n], o(t, n, e)))
    })(Function.prototype, "toString", function() {
      return "function" == typeof this && this[u] || c.call(this)
    })
  }, function(t, n, e) {
    var r = e(7),
      o = e(41),
      i = e(43),
      u = Object.defineProperty;
    n.f = e(8) ? Object.defineProperty : function(t, n, e) {
      if (r(t), n = i(n, !0), r(e), o) try {
        return u(t, n, e)
      } catch (t) {}
      if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
      return "value" in e && (t[n] = e.value), t
    }
  }, function(t, n, e) {
    var r = e(1);
    t.exports = function(t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t
    }
  }, function(t, n, e) {
    t.exports = !e(13)(function() {
      return 7 != Object.defineProperty({}, "a", {
        get: function() {
          return 7
        }
      }).a
    })
  }, function(t, n) {
    var e = {}.hasOwnProperty;
    t.exports = function(t, n) {
      return e.call(t, n)
    }
  }, function(t, n, e) {
    var r = e(44);
    t.exports = function(t, n, e) {
      if (r(t), void 0 === n) return t;
      switch (e) {
        case 1:
          return function(e) {
            return t.call(n, e)
          };
        case 2:
          return function(e, r) {
            return t.call(n, e, r)
          };
        case 3:
          return function(e, r, o) {
            return t.call(n, e, r, o)
          }
      }
      return function() {
        return t.apply(n, arguments)
      }
    }
  }, function(t, n, e) {
    var r = e(6),
      o = e(17);
    t.exports = e(8) ? function(t, n, e) {
      return r.f(t, n, o(1, e))
    } : function(t, n, e) {
      return t[n] = e, t
    }
  }, function(t, n, e) {
    var r = e(1);
    t.exports = function(t, n) {
      if (!r(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");
      return t
    }
  }, function(t, n) {
    t.exports = function(t) {
      try {
        return !!t()
      } catch (t) {
        return !0
      }
    }
  }, function(t, n) {
    t.exports = {}
  }, function(t, n, e) {
    var r = e(10),
      o = e(49),
      i = e(50),
      u = e(7),
      c = e(19),
      s = e(51),
      a = {},
      f = {};
    (n = t.exports = function(t, n, e, l, p) {
      var h, d, v, y, m = p ? function() {
          return t
        } : s(t),
        g = r(e, l, n ? 2 : 1),
        b = 0;
      if ("function" != typeof m) throw TypeError(t + " is not iterable!");
      if (i(m)) {
        for (h = c(t.length); h > b; b++)
          if ((y = n ? g(u(d = t[b])[0], d[1]) : g(t[b])) === a || y === f) return y
      } else
        for (v = m.call(t); !(d = v.next()).done;)
          if ((y = o(v, g, d.value, n)) === a || y === f) return y
    }).BREAK = a, n.RETURN = f
  }, function(t, n) {
    var e = 0,
      r = Math.random();
    t.exports = function(t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + r).toString(36))
    }
  }, function(t, n) {
    t.exports = function(t, n) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: n
      }
    }
  }, function(t, n, e) {
    var r = e(31),
      o = e(28);
    t.exports = function(t) {
      return r(o(t))
    }
  }, function(t, n, e) {
    var r = e(27),
      o = Math.min;
    t.exports = function(t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0
    }
  }, function(t, n, e) {
    var r = e(28);
    t.exports = function(t) {
      return Object(r(t))
    }
  }, function(t, n, e) {
    var r = e(16)("meta"),
      o = e(1),
      i = e(9),
      u = e(6).f,
      c = 0,
      s = Object.isExtensible || function() {
        return !0
      },
      a = !e(13)(function() {
        return s(Object.preventExtensions({}))
      }),
      f = function(t) {
        u(t, r, {
          value: {
            i: "O" + ++c,
            w: {}
          }
        })
      },
      l = t.exports = {
        KEY: r,
        NEED: !1,
        fastKey: function(t, n) {
          if (!o(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
          if (!i(t, r)) {
            if (!s(t)) return "F";
            if (!n) return "E";
            f(t)
          }
          return t[r].i
        },
        getWeak: function(t, n) {
          if (!i(t, r)) {
            if (!s(t)) return !0;
            if (!n) return !1;
            f(t)
          }
          return t[r].w
        },
        onFreeze: function(t) {
          return a && l.NEED && s(t) && !i(t, r) && f(t), t
        }
      }
  }, function(t, n, e) {
    "use strict";
    var r = e(23),
      o = {};
    o[e(0)("toStringTag")] = "z", o + "" != "[object z]" && e(5)(Object.prototype, "toString", function() {
      return "[object " + r(this) + "]"
    }, !0)
  }, function(t, n, e) {
    var r = e(24),
      o = e(0)("toStringTag"),
      i = "Arguments" == r(function() {
        return arguments
      }());
    t.exports = function(t) {
      var n, e, u;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof(e = function(t, n) {
        try {
          return t[n]
        } catch (t) {}
      }(n = Object(t), o)) ? e : i ? r(n) : "Object" == (u = r(n)) && "function" == typeof n.callee ? "Arguments" : u
    }
  }, function(t, n) {
    var e = {}.toString;
    t.exports = function(t) {
      return e.call(t).slice(8, -1)
    }
  }, function(t, n, e) {
    var r = e(3),
      o = e(2),
      i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
    (t.exports = function(t, n) {
      return i[t] || (i[t] = void 0 !== n ? n : {})
    })("versions", []).push({
      version: r.version,
      mode: e(40) ? "pure" : "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    })
  }, function(t, n, e) {
    "use strict";
    var r = e(61)(!0);
    e(29)(String, "String", function(t) {
      this._t = String(t), this._i = 0
    }, function() {
      var t, n = this._t,
        e = this._i;
      return e >= n.length ? {
        value: void 0,
        done: !0
      } : (t = r(n, e), this._i += t.length, {
        value: t,
        done: !1
      })
    })
  }, function(t, n) {
    var e = Math.ceil,
      r = Math.floor;
    t.exports = function(t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : e)(t)
    }
  }, function(t, n) {
    t.exports = function(t) {
      if (null == t) throw TypeError("Can't call method on  " + t);
      return t
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(40),
      o = e(4),
      i = e(5),
      u = e(11),
      c = e(14),
      s = e(62),
      a = e(33),
      f = e(68),
      l = e(0)("iterator"),
      p = !([].keys && "next" in [].keys()),
      h = function() {
        return this
      };
    t.exports = function(t, n, e, d, v, y, m) {
      s(e, n, d);
      var g, b, x, _ = function(t) {
          if (!p && t in O) return O[t];
          switch (t) {
            case "keys":
            case "values":
              return function() {
                return new e(this, t)
              }
          }
          return function() {
            return new e(this, t)
          }
        },
        w = n + " Iterator",
        S = "values" == v,
        E = !1,
        O = t.prototype,
        T = O[l] || O["@@iterator"] || v && O[v],
        A = T || _(v),
        M = v ? S ? _("entries") : A : void 0,
        P = "Array" == n && O.entries || T;
      if (P && (x = f(P.call(new t))) !== Object.prototype && x.next && (a(x, w, !0), r || "function" == typeof x[l] || u(x, l, h)), S && T && "values" !== T.name && (E = !0, A = function() {
          return T.call(this)
        }), r && !m || !p && !E && O[l] || u(O, l, A), c[n] = A, c[w] = h, v)
        if (g = {
            values: S ? A : _("values"),
            keys: y ? A : _("keys"),
            entries: M
          }, m)
          for (b in g) b in O || i(O, b, g[b]);
        else o(o.P + o.F * (p || E), n, g);
      return g
    }
  }, function(t, n, e) {
    var r = e(64),
      o = e(46);
    t.exports = Object.keys || function(t) {
      return r(t, o)
    }
  }, function(t, n, e) {
    var r = e(24);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
      return "String" == r(t) ? t.split("") : Object(t)
    }
  }, function(t, n, e) {
    var r = e(25)("keys"),
      o = e(16);
    t.exports = function(t) {
      return r[t] || (r[t] = o(t))
    }
  }, function(t, n, e) {
    var r = e(6).f,
      o = e(9),
      i = e(0)("toStringTag");
    t.exports = function(t, n, e) {
      t && !o(t = e ? t : t.prototype, i) && r(t, i, {
        configurable: !0,
        value: n
      })
    }
  }, function(t, n, e) {
    for (var r = e(69), o = e(30), i = e(5), u = e(2), c = e(11), s = e(14), a = e(0), f = a("iterator"), l = a("toStringTag"), p = s.Array, h = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1
      }, d = o(h), v = 0; v < d.length; v++) {
      var y, m = d[v],
        g = h[m],
        b = u[m],
        x = b && b.prototype;
      if (x && (x[f] || c(x, f, p), x[l] || c(x, l, m), s[m] = p, g))
        for (y in r) x[y] || i(x, y, r[y], !0)
    }
  }, function(t, n, e) {
    var r = e(5);
    t.exports = function(t, n, e) {
      for (var o in n) r(t, o, n[o], e);
      return t
    }
  }, function(t, n) {
    t.exports = function(t, n, e, r) {
      if (!(t instanceof n) || void 0 !== r && r in t) throw TypeError(e + ": incorrect invocation!");
      return t
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(2),
      o = e(4),
      i = e(5),
      u = e(35),
      c = e(21),
      s = e(15),
      a = e(36),
      f = e(1),
      l = e(13),
      p = e(52),
      h = e(33),
      d = e(73);
    t.exports = function(t, n, e, v, y, m) {
      var g = r[t],
        b = g,
        x = y ? "set" : "add",
        _ = b && b.prototype,
        w = {},
        S = function(t) {
          var n = _[t];
          i(_, t, "delete" == t ? function(t) {
            return !(m && !f(t)) && n.call(this, 0 === t ? 0 : t)
          } : "has" == t ? function(t) {
            return !(m && !f(t)) && n.call(this, 0 === t ? 0 : t)
          } : "get" == t ? function(t) {
            return m && !f(t) ? void 0 : n.call(this, 0 === t ? 0 : t)
          } : "add" == t ? function(t) {
            return n.call(this, 0 === t ? 0 : t), this
          } : function(t, e) {
            return n.call(this, 0 === t ? 0 : t, e), this
          })
        };
      if ("function" == typeof b && (m || _.forEach && !l(function() {
          (new b).entries().next()
        }))) {
        var E = new b,
          O = E[x](m ? {} : -0, 1) != E,
          T = l(function() {
            E.has(1)
          }),
          A = p(function(t) {
            new b(t)
          }),
          M = !m && l(function() {
            for (var t = new b, n = 5; n--;) t[x](n, n);
            return !t.has(-0)
          });
        A || ((b = n(function(n, e) {
          a(n, b, t);
          var r = d(new g, n, b);
          return null != e && s(e, y, r[x], r), r
        })).prototype = _, _.constructor = b), (T || M) && (S("delete"), S("has"), y && S("get")), (M || O) && S(x), m && _.clear && delete _.clear
      } else b = v.getConstructor(n, t, y, x), u(b.prototype, e), c.NEED = !0;
      return h(b, t), w[t] = b, o(o.G + o.W + o.F * (b != g), w), m || v.setStrong(b, t, y), b
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(4);
    t.exports = function(t) {
      r(r.S, t, {
        of: function() {
          for (var t = arguments.length, n = new Array(t); t--;) n[t] = arguments[t];
          return new this(n)
        }
      })
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(4),
      o = e(44),
      i = e(10),
      u = e(15);
    t.exports = function(t) {
      r(r.S, t, {
        from: function(t) {
          var n, e, r, c, s = arguments[1];
          return o(this), (n = void 0 !== s) && o(s), null == t ? new this : (e = [], n ? (r = 0, c = i(s, arguments[2], 2), u(t, !1, function(t) {
            e.push(c(t, r++))
          })) : u(t, !1, e.push, e), new this(e))
        }
      })
    }
  }, function(t, n) {
    t.exports = !1
  }, function(t, n, e) {
    t.exports = !e(8) && !e(13)(function() {
      return 7 != Object.defineProperty(e(42)("div"), "a", {
        get: function() {
          return 7
        }
      }).a
    })
  }, function(t, n, e) {
    var r = e(1),
      o = e(2).document,
      i = r(o) && r(o.createElement);
    t.exports = function(t) {
      return i ? o.createElement(t) : {}
    }
  }, function(t, n, e) {
    var r = e(1);
    t.exports = function(t, n) {
      if (!r(t)) return t;
      var e, o;
      if (n && "function" == typeof(e = t.toString) && !r(o = e.call(t))) return o;
      if ("function" == typeof(e = t.valueOf) && !r(o = e.call(t))) return o;
      if (!n && "function" == typeof(e = t.toString) && !r(o = e.call(t))) return o;
      throw TypeError("Can't convert object to primitive value")
    }
  }, function(t, n) {
    t.exports = function(t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t
    }
  }, function(t, n, e) {
    var r = e(7),
      o = e(63),
      i = e(46),
      u = e(32)("IE_PROTO"),
      c = function() {},
      s = function() {
        var t, n = e(42)("iframe"),
          r = i.length;
        for (n.style.display = "none", e(67).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), s = t.F; r--;) delete s.prototype[i[r]];
        return s()
      };
    t.exports = Object.create || function(t, n) {
      var e;
      return null !== t ? (c.prototype = r(t), e = new c, c.prototype = null, e[u] = t) : e = s(), void 0 === n ? e : o(e, n)
    }
  }, function(t, n) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")
  }, function(t, n) {
    t.exports = function(t, n) {
      return {
        value: n,
        done: !!t
      }
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(6).f,
      o = e(45),
      i = e(35),
      u = e(10),
      c = e(36),
      s = e(15),
      a = e(29),
      f = e(47),
      l = e(72),
      p = e(8),
      h = e(21).fastKey,
      d = e(12),
      v = p ? "_s" : "size",
      y = function(t, n) {
        var e, r = h(n);
        if ("F" !== r) return t._i[r];
        for (e = t._f; e; e = e.n)
          if (e.k == n) return e
      };
    t.exports = {
      getConstructor: function(t, n, e, a) {
        var f = t(function(t, r) {
          c(t, f, n, "_i"), t._t = n, t._i = o(null), t._f = void 0, t._l = void 0, t[v] = 0, null != r && s(r, e, t[a], t)
        });
        return i(f.prototype, {
          clear: function() {
            for (var t = d(this, n), e = t._i, r = t._f; r; r = r.n) r.r = !0, r.p && (r.p = r.p.n = void 0), delete e[r.i];
            t._f = t._l = void 0, t[v] = 0
          },
          delete: function(t) {
            var e = d(this, n),
              r = y(e, t);
            if (r) {
              var o = r.n,
                i = r.p;
              delete e._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), e._f == r && (e._f = o), e._l == r && (e._l = i), e[v]--
            }
            return !!r
          },
          forEach: function(t) {
            d(this, n);
            for (var e, r = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.n : this._f;)
              for (r(e.v, e.k, this); e && e.r;) e = e.p
          },
          has: function(t) {
            return !!y(d(this, n), t)
          }
        }), p && r(f.prototype, "size", {
          get: function() {
            return d(this, n)[v]
          }
        }), f
      },
      def: function(t, n, e) {
        var r, o, i = y(t, n);
        return i ? i.v = e : (t._l = i = {
          i: o = h(n, !0),
          k: n,
          v: e,
          p: r = t._l,
          n: void 0,
          r: !1
        }, t._f || (t._f = i), r && (r.n = i), t[v]++, "F" !== o && (t._i[o] = i)), t
      },
      getEntry: y,
      setStrong: function(t, n, e) {
        a(t, n, function(t, e) {
          this._t = d(t, n), this._k = e, this._l = void 0
        }, function() {
          for (var t = this._k, n = this._l; n && n.r;) n = n.p;
          return this._t && (this._l = n = n ? n.n : this._t._f) ? f(0, "keys" == t ? n.k : "values" == t ? n.v : [n.k, n.v]) : (this._t = void 0, f(1))
        }, e ? "entries" : "values", !e, !0), l(n)
      }
    }
  }, function(t, n, e) {
    var r = e(7);
    t.exports = function(t, n, e, o) {
      try {
        return o ? n(r(e)[0], e[1]) : n(e)
      } catch (n) {
        var i = t.return;
        throw void 0 !== i && r(i.call(t)), n
      }
    }
  }, function(t, n, e) {
    var r = e(14),
      o = e(0)("iterator"),
      i = Array.prototype;
    t.exports = function(t) {
      return void 0 !== t && (r.Array === t || i[o] === t)
    }
  }, function(t, n, e) {
    var r = e(23),
      o = e(0)("iterator"),
      i = e(14);
    t.exports = e(3).getIteratorMethod = function(t) {
      if (null != t) return t[o] || t["@@iterator"] || i[r(t)]
    }
  }, function(t, n, e) {
    var r = e(0)("iterator"),
      o = !1;
    try {
      var i = [7][r]();
      i.return = function() {
        o = !0
      }, Array.from(i, function() {
        throw 2
      })
    } catch (t) {}
    t.exports = function(t, n) {
      if (!n && !o) return !1;
      var e = !1;
      try {
        var i = [7],
          u = i[r]();
        u.next = function() {
          return {
            done: e = !0
          }
        }, i[r] = function() {
          return u
        }, t(i)
      } catch (t) {}
      return e
    }
  }, function(t, n) {
    n.f = {}.propertyIsEnumerable
  }, function(t, n, e) {
    var r = e(23),
      o = e(77);
    t.exports = function(t) {
      return function() {
        if (r(this) != t) throw TypeError(t + "#toJSON isn't generic");
        return o(this)
      }
    }
  }, function(t, n, e) {
    var r = e(10),
      o = e(31),
      i = e(20),
      u = e(19),
      c = e(87);
    t.exports = function(t, n) {
      var e = 1 == t,
        s = 2 == t,
        a = 3 == t,
        f = 4 == t,
        l = 6 == t,
        p = 5 == t || l,
        h = n || c;
      return function(n, c, d) {
        for (var v, y, m = i(n), g = o(m), b = r(c, d, 3), x = u(g.length), _ = 0, w = e ? h(n, x) : s ? h(n, 0) : void 0; x > _; _++)
          if ((p || _ in g) && (y = b(v = g[_], _, m), t))
            if (e) w[_] = y;
            else if (y) switch (t) {
          case 3:
            return !0;
          case 5:
            return v;
          case 6:
            return _;
          case 2:
            w.push(v)
        } else if (f) return !1;
        return l ? -1 : a || f ? f : w
      }
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(30),
      o = e(90),
      i = e(53),
      u = e(20),
      c = e(31),
      s = Object.assign;
    t.exports = !s || e(13)(function() {
      var t = {},
        n = {},
        e = Symbol(),
        r = "abcdefghijklmnopqrst";
      return t[e] = 7, r.split("").forEach(function(t) {
        n[t] = t
      }), 7 != s({}, t)[e] || Object.keys(s({}, n)).join("") != r
    }) ? function(t, n) {
      for (var e = u(t), s = arguments.length, a = 1, f = o.f, l = i.f; s > a;)
        for (var p, h = c(arguments[a++]), d = f ? r(h).concat(f(h)) : r(h), v = d.length, y = 0; v > y;) l.call(h, p = d[y++]) && (e[p] = h[p]);
      return e
    } : s
  }, function(t, n, e) {
    "use strict";
    (function(t) {
      var e = "object" == typeof t && t && t.Object === Object && t;
      n.a = e
    }).call(this, e(99))
  }, function(t, n, e) {
    t.exports = e(100)
  }, function(t, n, e) {
    e(22), e(26), e(34), e(71), e(76), e(78), e(79), t.exports = e(3).Map
  }, function(t, n, e) {
    t.exports = e(25)("native-function-to-string", Function.toString)
  }, function(t, n, e) {
    var r = e(27),
      o = e(28);
    t.exports = function(t) {
      return function(n, e) {
        var i, u, c = String(o(n)),
          s = r(e),
          a = c.length;
        return s < 0 || s >= a ? t ? "" : void 0 : (i = c.charCodeAt(s)) < 55296 || i > 56319 || s + 1 === a || (u = c.charCodeAt(s + 1)) < 56320 || u > 57343 ? t ? c.charAt(s) : i : t ? c.slice(s, s + 2) : u - 56320 + (i - 55296 << 10) + 65536
      }
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(45),
      o = e(17),
      i = e(33),
      u = {};
    e(11)(u, e(0)("iterator"), function() {
      return this
    }), t.exports = function(t, n, e) {
      t.prototype = r(u, {
        next: o(1, e)
      }), i(t, n + " Iterator")
    }
  }, function(t, n, e) {
    var r = e(6),
      o = e(7),
      i = e(30);
    t.exports = e(8) ? Object.defineProperties : function(t, n) {
      o(t);
      for (var e, u = i(n), c = u.length, s = 0; c > s;) r.f(t, e = u[s++], n[e]);
      return t
    }
  }, function(t, n, e) {
    var r = e(9),
      o = e(18),
      i = e(65)(!1),
      u = e(32)("IE_PROTO");
    t.exports = function(t, n) {
      var e, c = o(t),
        s = 0,
        a = [];
      for (e in c) e != u && r(c, e) && a.push(e);
      for (; n.length > s;) r(c, e = n[s++]) && (~i(a, e) || a.push(e));
      return a
    }
  }, function(t, n, e) {
    var r = e(18),
      o = e(19),
      i = e(66);
    t.exports = function(t) {
      return function(n, e, u) {
        var c, s = r(n),
          a = o(s.length),
          f = i(u, a);
        if (t && e != e) {
          for (; a > f;)
            if ((c = s[f++]) != c) return !0
        } else
          for (; a > f; f++)
            if ((t || f in s) && s[f] === e) return t || f || 0;
        return !t && -1
      }
    }
  }, function(t, n, e) {
    var r = e(27),
      o = Math.max,
      i = Math.min;
    t.exports = function(t, n) {
      return (t = r(t)) < 0 ? o(t + n, 0) : i(t, n)
    }
  }, function(t, n, e) {
    var r = e(2).document;
    t.exports = r && r.documentElement
  }, function(t, n, e) {
    var r = e(9),
      o = e(20),
      i = e(32)("IE_PROTO"),
      u = Object.prototype;
    t.exports = Object.getPrototypeOf || function(t) {
      return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(70),
      o = e(47),
      i = e(14),
      u = e(18);
    t.exports = e(29)(Array, "Array", function(t, n) {
      this._t = u(t), this._i = 0, this._k = n
    }, function() {
      var t = this._t,
        n = this._k,
        e = this._i++;
      return !t || e >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == n ? e : "values" == n ? t[e] : [e, t[e]])
    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries")
  }, function(t, n, e) {
    var r = e(0)("unscopables"),
      o = Array.prototype;
    null == o[r] && e(11)(o, r, {}), t.exports = function(t) {
      o[r][t] = !0
    }
  }, function(t, n, e) {
    "use strict";
    var r = e(48),
      o = e(12);
    t.exports = e(37)("Map", function(t) {
      return function() {
        return t(this, arguments.length > 0 ? arguments[0] : void 0)
      }
    }, {
      get: function(t) {
        var n = r.getEntry(o(this, "Map"), t);
        return n && n.v
      },
      set: function(t, n) {
        return r.def(o(this, "Map"), 0 === t ? 0 : t, n)
      }
    }, r, !0)
  }, function(t, n, e) {
    "use strict";
    var r = e(2),
      o = e(6),
      i = e(8),
      u = e(0)("species");
    t.exports = function(t) {
      var n = r[t];
      i && n && !n[u] && o.f(n, u, {
        configurable: !0,
        get: function() {
          return this
        }
      })
    }
  }, function(t, n, e) {
    var r = e(1),
      o = e(74).set;
    t.exports = function(t, n, e) {
      var i, u = n.constructor;
      return u !== e && "function" == typeof u && (i = u.prototype) !== e.prototype && r(i) && o && o(t, i), t
    }
  }, function(t, n, e) {
    var r = e(1),
      o = e(7),
      i = function(t, n) {
        if (o(t), !r(n) && null !== n) throw TypeError(n + ": can't set as prototype!")
      };
    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, n, r) {
        try {
          (r = e(10)(Function.call, e(75).f(Object.prototype, "__proto__").set, 2))(t, []), n = !(t instanceof Array)
        } catch (t) {
          n = !0
        }
        return function(t, e) {
          return i(t, e), n ? t.__proto__ = e : r(t, e), t
        }
      }({}, !1) : void 0),
      check: i
    }
  }, function(t, n, e) {
    var r = e(53),
      o = e(17),
      i = e(18),
      u = e(43),
      c = e(9),
      s = e(41),
      a = Object.getOwnPropertyDescriptor;
    n.f = e(8) ? a : function(t, n) {
      if (t = i(t), n = u(n, !0), s) try {
        return a(t, n)
      } catch (t) {}
      if (c(t, n)) return o(!r.f.call(t, n), t[n])
    }
  }, function(t, n, e) {
    var r = e(4);
    r(r.P + r.R, "Map", {
      toJSON: e(54)("Map")
    })
  }, function(t, n, e) {
    var r = e(15);
    t.exports = function(t, n) {
      var e = [];
      return r(t, !1, e.push, e, n), e
    }
  }, function(t, n, e) {
    e(38)("Map")
  }, function(t, n, e) {
    e(39)("Map")
  }, function(t, n, e) {
    e(22), e(26), e(34), e(81), e(82), e(83), e(84), t.exports = e(3).Set
  }, function(t, n, e) {
    "use strict";
    var r = e(48),
      o = e(12);
    t.exports = e(37)("Set", function(t) {
      return function() {
        return t(this, arguments.length > 0 ? arguments[0] : void 0)
      }
    }, {
      add: function(t) {
        return r.def(o(this, "Set"), t = 0 === t ? 0 : t, t)
      }
    }, r)
  }, function(t, n, e) {
    var r = e(4);
    r(r.P + r.R, "Set", {
      toJSON: e(54)("Set")
    })
  }, function(t, n, e) {
    e(38)("Set")
  }, function(t, n, e) {
    e(39)("Set")
  }, function(t, n, e) {
    e(22), e(34), e(86), e(92), e(93), t.exports = e(3).WeakMap
  }, function(t, n, e) {
    "use strict";
    var r, o = e(2),
      i = e(55)(0),
      u = e(5),
      c = e(21),
      s = e(56),
      a = e(91),
      f = e(1),
      l = e(12),
      p = e(12),
      h = !o.ActiveXObject && "ActiveXObject" in o,
      d = c.getWeak,
      v = Object.isExtensible,
      y = a.ufstore,
      m = function(t) {
        return function() {
          return t(this, arguments.length > 0 ? arguments[0] : void 0)
        }
      },
      g = {
        get: function(t) {
          if (f(t)) {
            var n = d(t);
            return !0 === n ? y(l(this, "WeakMap")).get(t) : n ? n[this._i] : void 0
          }
        },
        set: function(t, n) {
          return a.def(l(this, "WeakMap"), t, n)
        }
      },
      b = t.exports = e(37)("WeakMap", m, g, a, !0, !0);
    p && h && (s((r = a.getConstructor(m, "WeakMap")).prototype, g), c.NEED = !0, i(["delete", "has", "get", "set"], function(t) {
      var n = b.prototype,
        e = n[t];
      u(n, t, function(n, o) {
        if (f(n) && !v(n)) {
          this._f || (this._f = new r);
          var i = this._f[t](n, o);
          return "set" == t ? this : i
        }
        return e.call(this, n, o)
      })
    }))
  }, function(t, n, e) {
    var r = e(88);
    t.exports = function(t, n) {
      return new(r(t))(n)
    }
  }, function(t, n, e) {
    var r = e(1),
      o = e(89),
      i = e(0)("species");
    t.exports = function(t) {
      var n;
      return o(t) && ("function" != typeof(n = t.constructor) || n !== Array && !o(n.prototype) || (n = void 0), r(n) && null === (n = n[i]) && (n = void 0)), void 0 === n ? Array : n
    }
  }, function(t, n, e) {
    var r = e(24);
    t.exports = Array.isArray || function(t) {
      return "Array" == r(t)
    }
  }, function(t, n) {
    n.f = Object.getOwnPropertySymbols
  }, function(t, n, e) {
    "use strict";
    var r = e(35),
      o = e(21).getWeak,
      i = e(7),
      u = e(1),
      c = e(36),
      s = e(15),
      a = e(55),
      f = e(9),
      l = e(12),
      p = a(5),
      h = a(6),
      d = 0,
      v = function(t) {
        return t._l || (t._l = new y)
      },
      y = function() {
        this.a = []
      },
      m = function(t, n) {
        return p(t.a, function(t) {
          return t[0] === n
        })
      };
    y.prototype = {
      get: function(t) {
        var n = m(this, t);
        if (n) return n[1]
      },
      has: function(t) {
        return !!m(this, t)
      },
      set: function(t, n) {
        var e = m(this, t);
        e ? e[1] = n : this.a.push([t, n])
      },
      delete: function(t) {
        var n = h(this.a, function(n) {
          return n[0] === t
        });
        return ~n && this.a.splice(n, 1), !!~n
      }
    }, t.exports = {
      getConstructor: function(t, n, e, i) {
        var a = t(function(t, r) {
          c(t, a, n, "_i"), t._t = n, t._i = d++, t._l = void 0, null != r && s(r, e, t[i], t)
        });
        return r(a.prototype, {
          delete: function(t) {
            if (!u(t)) return !1;
            var e = o(t);
            return !0 === e ? v(l(this, n)).delete(t) : e && f(e, this._i) && delete e[this._i]
          },
          has: function(t) {
            if (!u(t)) return !1;
            var e = o(t);
            return !0 === e ? v(l(this, n)).has(t) : e && f(e, this._i)
          }
        }), a
      },
      def: function(t, n, e) {
        var r = o(i(n), !0);
        return !0 === r ? v(t).set(n, e) : r[t._i] = e, t
      },
      ufstore: v
    }
  }, function(t, n, e) {
    e(38)("WeakMap")
  }, function(t, n, e) {
    e(39)("WeakMap")
  }, function(t, n, e) {
    e(26), e(95), t.exports = e(3).Array.from
  }, function(t, n, e) {
    "use strict";
    var r = e(10),
      o = e(4),
      i = e(20),
      u = e(49),
      c = e(50),
      s = e(19),
      a = e(96),
      f = e(51);
    o(o.S + o.F * !e(52)(function(t) {
      Array.from(t)
    }), "Array", {
      from: function(t) {
        var n, e, o, l, p = i(t),
          h = "function" == typeof this ? this : Array,
          d = arguments.length,
          v = d > 1 ? arguments[1] : void 0,
          y = void 0 !== v,
          m = 0,
          g = f(p);
        if (y && (v = r(v, d > 2 ? arguments[2] : void 0, 2)), null == g || h == Array && c(g))
          for (e = new h(n = s(p.length)); n > m; m++) a(e, m, y ? v(p[m], m) : p[m]);
        else
          for (l = g.call(p), e = new h; !(o = l.next()).done; m++) a(e, m, y ? u(l, v, [o.value, m], !0) : o.value);
        return e.length = m, e
      }
    })
  }, function(t, n, e) {
    "use strict";
    var r = e(6),
      o = e(17);
    t.exports = function(t, n, e) {
      n in t ? r.f(t, n, o(0, e)) : t[n] = e
    }
  }, function(t, n, e) {
    e(98), t.exports = e(3).Object.assign
  }, function(t, n, e) {
    var r = e(4);
    r(r.S + r.F, "Object", {
      assign: e(56)
    })
  }, function(t, n) {
    var e;
    e = function() {
      return this
    }();
    try {
      e = e || new Function("return this")()
    } catch (t) {
      "object" == typeof window && (e = window)
    }
    t.exports = e
  }, function(t, n, e) {
    "use strict";
    e.r(n);
    var r = {};
    e.r(r), e.d(r, "keyboardHandler", function() {
      return et
    }), e.d(r, "mouseHandler", function() {
      return rt
    }), e.d(r, "resizeHandler", function() {
      return ot
    }), e.d(r, "selectHandler", function() {
      return it
    }), e.d(r, "touchHandler", function() {
      return ut
    }), e.d(r, "wheelHandler", function() {
      return ct
    });
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    var o = function(t, n) {
        return (o = Object.setPrototypeOf || {
            __proto__: []
          }
          instanceof Array && function(t, n) {
            t.__proto__ = n
          } || function(t, n) {
            for (var e in n) n.hasOwnProperty(e) && (t[e] = n[e])
          })(t, n)
      },
      i = function() {
        return (i = Object.assign || function(t) {
          for (var n, e = 1, r = arguments.length; e < r; e++)
            for (var o in n = arguments[e]) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
          return t
        }).apply(this, arguments)
      };

    function u(t, n, e, r) {
      var o, i = arguments.length,
        u = i < 3 ? n : null === r ? r = Object.getOwnPropertyDescriptor(n, e) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(t, n, e, r);
      else
        for (var c = t.length - 1; c >= 0; c--)(o = t[c]) && (u = (i < 3 ? o(u) : i > 3 ? o(n, e, u) : o(n, e)) || u);
      return i > 3 && u && Object.defineProperty(n, e, u), u
    }
    e(59), e(80), e(85), e(94), e(97);
    var c = function(t) {
        var n = typeof t;
        return null != t && ("object" == n || "function" == n)
      },
      s = e(57),
      a = "object" == typeof self && self && self.Object === Object && self,
      f = s.a || a || Function("return this")(),
      l = f.Symbol,
      p = Object.prototype,
      h = p.hasOwnProperty,
      d = p.toString,
      v = l ? l.toStringTag : void 0,
      y = Object.prototype.toString,
      m = l ? l.toStringTag : void 0,
      g = function(t) {
        return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : m && m in Object(t) ? function(t) {
          var n = h.call(t, v),
            e = t[v];
          try {
            t[v] = void 0;
            var r = !0
          } catch (t) {}
          var o = d.call(t);
          return r && (n ? t[v] = e : delete t[v]), o
        }(t) : function(t) {
          return y.call(t)
        }(t)
      },
      b = /^\s+|\s+$/g,
      x = /^[-+]0x[0-9a-f]+$/i,
      _ = /^0b[01]+$/i,
      w = /^0o[0-7]+$/i,
      S = parseInt,
      E = function(t) {
        if ("number" == typeof t) return t;
        if (function(t) {
            return "symbol" == typeof t || function(t) {
              return null != t && "object" == typeof t
            }(t) && "[object Symbol]" == g(t)
          }(t)) return NaN;
        if (c(t)) {
          var n = "function" == typeof t.valueOf ? t.valueOf() : t;
          t = c(n) ? n + "" : n
        }
        if ("string" != typeof t) return 0 === t ? t : +t;
        t = t.replace(b, "");
        var e = _.test(t);
        return e || w.test(t) ? S(t.slice(2), e ? 2 : 8) : x.test(t) ? NaN : +t
      },
      O = function(t, n, e) {
        return void 0 === e && (e = n, n = void 0), void 0 !== e && (e = (e = E(e)) == e ? e : 0), void 0 !== n && (n = (n = E(n)) == n ? n : 0),
          function(t, n, e) {
            return t == t && (void 0 !== e && (t = t <= e ? t : e), void 0 !== n && (t = t >= n ? t : n)), t
          }(E(t), n, e)
      };

    function T(t, n) {
      return void 0 === t && (t = -1 / 0), void 0 === n && (n = 1 / 0),
        function(e, r) {
          var o = "_" + r;
          Object.defineProperty(e, r, {
            get: function() {
              return this[o]
            },
            set: function(e) {
              Object.defineProperty(this, o, {
                value: O(e, t, n),
                enumerable: !1,
                writable: !0,
                configurable: !0
              })
            },
            enumerable: !0,
            configurable: !0
          })
        }
    }

    function A(t, n) {
      var e = "_" + n;
      Object.defineProperty(t, n, {
        get: function() {
          return this[e]
        },
        set: function(t) {
          Object.defineProperty(this, e, {
            value: !!t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          })
        },
        enumerable: !0,
        configurable: !0
      })
    }
    var M = function() {
        return f.Date.now()
      },
      P = Math.max,
      j = Math.min,
      k = function(t, n, e) {
        var r, o, i, u, s, a, f = 0,
          l = !1,
          p = !1,
          h = !0;
        if ("function" != typeof t) throw new TypeError("Expected a function");

        function d(n) {
          var e = r,
            i = o;
          return r = o = void 0, f = n, u = t.apply(i, e)
        }

        function v(t) {
          var e = t - a;
          return void 0 === a || e >= n || e < 0 || p && t - f >= i
        }

        function y() {
          var t = M();
          if (v(t)) return m(t);
          s = setTimeout(y, function(t) {
            var e = n - (t - a);
            return p ? j(e, i - (t - f)) : e
          }(t))
        }

        function m(t) {
          return s = void 0, h && r ? d(t) : (r = o = void 0, u)
        }

        function g() {
          var t = M(),
            e = v(t);
          if (r = arguments, o = this, a = t, e) {
            if (void 0 === s) return function(t) {
              return f = t, s = setTimeout(y, n), l ? d(t) : u
            }(a);
            if (p) return s = setTimeout(y, n), d(a)
          }
          return void 0 === s && (s = setTimeout(y, n)), u
        }
        return n = E(n) || 0, c(e) && (l = !!e.leading, i = (p = "maxWait" in e) ? P(E(e.maxWait) || 0, n) : i, h = "trailing" in e ? !!e.trailing : h), g.cancel = function() {
          void 0 !== s && clearTimeout(s), f = 0, r = a = o = s = void 0
        }, g.flush = function() {
          return void 0 === s ? u : m(M())
        }, g
      };

    function D() {
      for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
      return function(n, e, r) {
        var o = r.value;
        return {
          get: function() {
            return this.hasOwnProperty(e) || Object.defineProperty(this, e, {
              value: k.apply(void 0, [o].concat(t))
            }), this[e]
          }
        }
      }
    }
    var L, N = function() {
        function t(t) {
          var n = this;
          void 0 === t && (t = {}), this.damping = .1, this.thumbMinSize = 20, this.renderByPixels = !0, this.alwaysShowTracks = !1, this.continuousScrolling = !0, this.delegateTo = null, this.plugins = {}, Object.keys(t).forEach(function(e) {
            n[e] = t[e]
          })
        }
        return Object.defineProperty(t.prototype, "wheelEventTarget", {
          get: function() {
            return this.delegateTo
          },
          set: function(t) {
            console.warn("[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."), this.delegateTo = t
          },
          enumerable: !0,
          configurable: !0
        }), u([T(0, 1)], t.prototype, "damping", void 0), u([T(0, 1 / 0)], t.prototype, "thumbMinSize", void 0), u([A], t.prototype, "renderByPixels", void 0), u([A], t.prototype, "alwaysShowTracks", void 0), u([A], t.prototype, "continuousScrolling", void 0), t
      }(),
      z = new WeakMap;

    function C() {
      if (void 0 !== L) return L;
      var t = !1;
      try {
        var n = function() {},
          e = Object.defineProperty({}, "passive", {
            get: function() {
              t = !0
            }
          });
        window.addEventListener("testPassive", n, e), window.removeEventListener("testPassive", n, e)
      } catch (t) {}
      return L = !!t && {
        passive: !1
      }
    }

    function R(t) {
      var n = z.get(t) || [];
      return z.set(t, n),
        function(t, e, r) {
          function o(t) {
            t.defaultPrevented || r(t)
          }
          e.split(/\s+/g).forEach(function(e) {
            n.push({
              elem: t,
              eventName: e,
              handler: o
            }), t.addEventListener(e, o, C())
          })
        }
    }

    function F(t) {
      var n = function(t) {
        return t.touches ? t.touches[t.touches.length - 1] : t
      }(t);
      return {
        x: n.clientX,
        y: n.clientY
      }
    }

    function I(t, n) {
      return void 0 === n && (n = []), n.some(function(n) {
        return t === n
      })
    }
    var W = ["webkit", "moz", "ms", "o"],
      H = new RegExp("^-(?!(?:" + W.join("|") + ")-)");

    function B(t, n) {
      n = function(t) {
        var n = {};
        return Object.keys(t).forEach(function(e) {
          if (H.test(e)) {
            var r = t[e];
            e = e.replace(/^-/, ""), n[e] = r, W.forEach(function(t) {
              n["-" + t + "-" + e] = r
            })
          } else n[e] = t[e]
        }), n
      }(n), Object.keys(n).forEach(function(e) {
        var r = e.replace(/^-/, "").replace(/-([a-z])/g, function(t, n) {
          return n.toUpperCase()
        });
        t.style[r] = n[e]
      })
    }
    var G, X = function() {
        function t(t) {
          this.updateTime = Date.now(), this.delta = {
            x: 0,
            y: 0
          }, this.velocity = {
            x: 0,
            y: 0
          }, this.lastPosition = {
            x: 0,
            y: 0
          }, this.lastPosition = F(t)
        }
        return t.prototype.update = function(t) {
          var n = this.velocity,
            e = this.updateTime,
            r = this.lastPosition,
            o = Date.now(),
            i = F(t),
            u = {
              x: -(i.x - r.x),
              y: -(i.y - r.y)
            },
            c = o - e || 16,
            s = u.x / c * 16,
            a = u.y / c * 16;
          n.x = .9 * s + .1 * n.x, n.y = .9 * a + .1 * n.y, this.delta = u, this.updateTime = o, this.lastPosition = i
        }, t
      }(),
      V = function() {
        function t() {
          this._touchList = {}
        }
        return Object.defineProperty(t.prototype, "_primitiveValue", {
          get: function() {
            return {
              x: 0,
              y: 0
            }
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.isActive = function() {
          return void 0 !== this._activeTouchID
        }, t.prototype.getDelta = function() {
          var t = this._getActiveTracker();
          return t ? i({}, t.delta) : this._primitiveValue
        }, t.prototype.getVelocity = function() {
          var t = this._getActiveTracker();
          return t ? i({}, t.velocity) : this._primitiveValue
        }, t.prototype.track = function(t) {
          var n = this,
            e = t.targetTouches;
          return Array.from(e).forEach(function(t) {
            n._add(t)
          }), this._touchList
        }, t.prototype.update = function(t) {
          var n = this,
            e = t.touches,
            r = t.changedTouches;
          return Array.from(e).forEach(function(t) {
            n._renew(t)
          }), this._setActiveID(r), this._touchList
        }, t.prototype.release = function(t) {
          var n = this;
          delete this._activeTouchID, Array.from(t.changedTouches).forEach(function(t) {
            n._delete(t)
          })
        }, t.prototype._add = function(t) {
          if (!this._has(t)) {
            var n = new X(t);
            this._touchList[t.identifier] = n
          }
        }, t.prototype._renew = function(t) {
          this._has(t) && this._touchList[t.identifier].update(t)
        }, t.prototype._delete = function(t) {
          delete this._touchList[t.identifier]
        }, t.prototype._has = function(t) {
          return this._touchList.hasOwnProperty(t.identifier)
        }, t.prototype._setActiveID = function(t) {
          this._activeTouchID = t[t.length - 1].identifier
        }, t.prototype._getActiveTracker = function() {
          return this._touchList[this._activeTouchID]
        }, t
      }();
    ! function(t) {
      t.X = "x", t.Y = "y"
    }(G || (G = {}));
    var U = function() {
        function t(t, n) {
          void 0 === n && (n = 0), this._direction = t, this._minSize = n, this.element = document.createElement("div"), this.displaySize = 0, this.realSize = 0, this.offset = 0, this.element.className = "scrollbar-thumb scrollbar-thumb-" + t
        }
        return t.prototype.attachTo = function(t) {
          t.appendChild(this.element)
        }, t.prototype.update = function(t, n, e) {
          this.realSize = Math.min(n / e, 1) * n, this.displaySize = Math.max(this.realSize, this._minSize), this.offset = t / e * (n + (this.realSize - this.displaySize)), B(this.element, this._getStyle())
        }, t.prototype._getStyle = function() {
          switch (this._direction) {
            case G.X:
              return {
                width: this.displaySize + "px", "-transform": "translate3d(" + this.offset + "px, 0, 0)"
              };
            case G.Y:
              return {
                height: this.displaySize + "px", "-transform": "translate3d(0, " + this.offset + "px, 0)"
              };
            default:
              return null
          }
        }, t
      }(),
      Y = function() {
        function t(t, n) {
          void 0 === n && (n = 0), this.element = document.createElement("div"), this._isShown = !1, this.element.className = "scrollbar-track scrollbar-track-" + t, this.thumb = new U(t, n), this.thumb.attachTo(this.element)
        }
        return t.prototype.attachTo = function(t) {
          t.appendChild(this.element)
        }, t.prototype.show = function() {
          this._isShown || (this._isShown = !0, this.element.classList.add("show"))
        }, t.prototype.hide = function() {
          this._isShown && (this._isShown = !1, this.element.classList.remove("show"))
        }, t.prototype.update = function(t, n, e) {
          B(this.element, {
            display: e <= n ? "none" : "block"
          }), this.thumb.update(t, n, e)
        }, t
      }(),
      q = function() {
        function t(t) {
          this._scrollbar = t;
          var n = t.options.thumbMinSize;
          this.xAxis = new Y(G.X, n), this.yAxis = new Y(G.Y, n), this.xAxis.attachTo(t.containerEl), this.yAxis.attachTo(t.containerEl), t.options.alwaysShowTracks && (this.xAxis.show(), this.yAxis.show())
        }
        return t.prototype.update = function() {
          var t = this._scrollbar,
            n = t.size,
            e = t.offset;
          this.xAxis.update(e.x, n.container.width, n.content.width), this.yAxis.update(e.y, n.container.height, n.content.height)
        }, t.prototype.autoHideOnIdle = function() {
          this._scrollbar.options.alwaysShowTracks || (this.xAxis.hide(), this.yAxis.hide())
        }, u([D(300)], t.prototype, "autoHideOnIdle", null), t
      }(),
      K = new WeakMap;

    function $(t) {
      return Math.pow(t - 1, 3) + 1
    }
    var J, Q, Z, tt = function() {
        function t(t, n) {
          var e = this.constructor;
          this.scrollbar = t, this.name = e.pluginName, this.options = i({}, e.defaultOptions, n)
        }
        return t.prototype.onInit = function() {}, t.prototype.onDestory = function() {}, t.prototype.onUpdate = function() {}, t.prototype.onRender = function(t) {}, t.prototype.transformDelta = function(t, n) {
          return i({}, t)
        }, t.pluginName = "", t.defaultOptions = {}, t
      }(),
      nt = {
        order: new Set,
        constructors: {}
      };

    function et(t) {
      var n = R(t),
        e = t.containerEl;
      n(e, "keydown", function(n) {
        var r = document.activeElement;
        if ((r === e || e.contains(r)) && ! function(t) {
            return ("INPUT" === t.tagName || "TEXTAREA" === t.tagName) && !t.disabled
          }(r)) {
          var o = function(t, n) {
            var e = t.size,
              r = t.limit,
              o = t.offset;
            switch (n) {
              case J.TAB:
                return function(t) {
                  requestAnimationFrame(function() {
                    t.scrollIntoView(document.activeElement, {
                      offsetTop: t.size.container.height / 2,
                      onlyScrollIfNeeded: !0
                    })
                  })
                }(t);
              case J.SPACE:
                return [0, 200];
              case J.PAGE_UP:
                return [0, 40 - e.container.height];
              case J.PAGE_DOWN:
                return [0, e.container.height - 40];
              case J.END:
                return [0, r.y - o.y];
              case J.HOME:
                return [0, -o.y];
              case J.LEFT:
                return [-40, 0];
              case J.UP:
                return [0, -40];
              case J.RIGHT:
                return [40, 0];
              case J.DOWN:
                return [0, 40];
              default:
                return null
            }
          }(t, n.keyCode || n.which);
          if (o) {
            var i = o[0],
              u = o[1];
            t.addTransformableMomentum(i, u, n, function(e) {
              e ? n.preventDefault() : (t.containerEl.blur(), t.parent && t.parent.containerEl.focus())
            })
          }
        }
      })
    }

    function rt(t) {
      var n, e, r, o, i, u = R(t),
        c = t.containerEl,
        s = t.track,
        a = s.xAxis,
        f = s.yAxis;

      function l(n, e) {
        var r = t.size;
        return n === Q.X ? e / (r.container.width + (a.thumb.realSize - a.thumb.displaySize)) * r.content.width : n === Q.Y ? e / (r.container.height + (f.thumb.realSize - f.thumb.displaySize)) * r.content.height : 0
      }

      function p(t) {
        return I(t, [a.element, a.thumb.element]) ? Q.X : I(t, [f.element, f.thumb.element]) ? Q.Y : void 0
      }
      u(c, "click", function(n) {
        if (!e && I(n.target, [a.element, f.element])) {
          var r = n.target,
            o = p(r),
            i = r.getBoundingClientRect(),
            u = F(n),
            c = t.offset,
            s = t.limit;
          if (o === Q.X) {
            var h = u.x - i.left - a.thumb.displaySize / 2;
            t.setMomentum(O(l(o, h) - c.x, -c.x, s.x - c.x), 0)
          }
          o === Q.Y && (h = u.y - i.top - f.thumb.displaySize / 2, t.setMomentum(0, O(l(o, h) - c.y, -c.y, s.y - c.y)))
        }
      }), u(c, "mousedown", function(e) {
        if (I(e.target, [a.thumb.element, f.thumb.element])) {
          n = !0;
          var u = e.target,
            s = F(e),
            l = u.getBoundingClientRect();
          o = p(u), r = {
            x: s.x - l.left,
            y: s.y - l.top
          }, i = c.getBoundingClientRect(), B(t.containerEl, {
            "-user-select": "none"
          })
        }
      }), u(window, "mousemove", function(u) {
        if (n) {
          e = !0;
          var c = t.offset,
            s = F(u);
          if (o === Q.X) {
            var a = s.x - r.x - i.left;
            t.setPosition(l(o, a), c.y)
          }
          o === Q.Y && (a = s.y - r.y - i.top, t.setPosition(c.x, l(o, a)))
        }
      }), u(window, "mouseup blur", function() {
        n = e = !1, B(t.containerEl, {
          "-user-select": ""
        })
      })
    }

    function ot(t) {
      R(t)(window, "resize", k(t.update.bind(t), 300))
    }

    function it(t) {
      var n, e = R(t),
        r = t.containerEl,
        o = t.contentEl,
        i = t.offset,
        u = t.limit,
        c = !1;
      e(window, "mousemove", function(e) {
        c && (cancelAnimationFrame(n), function e(r) {
          var o = r.x,
            c = r.y;
          (o || c) && (t.setMomentum(O(i.x + o, 0, u.x) - i.x, O(i.y + c, 0, u.y) - i.y), n = requestAnimationFrame(function() {
            e({
              x: o,
              y: c
            })
          }))
        }(function(t, n) {
          var e = t.bounding,
            r = e.top,
            o = e.right,
            i = e.bottom,
            u = e.left,
            c = F(n),
            s = c.x,
            a = c.y,
            f = {
              x: 0,
              y: 0
            };
          return 0 === s && 0 === a ? f : (s > o - 20 ? f.x = s - o + 20 : s < u + 20 && (f.x = s - u - 20), a > i - 20 ? f.y = a - i + 20 : a < r + 20 && (f.y = a - r - 20), f.x *= 2, f.y *= 2, f)
        }(t, e)))
      }), e(o, "selectstart", function(t) {
        t.stopPropagation(), cancelAnimationFrame(n), c = !0
      }), e(window, "mouseup blur", function() {
        cancelAnimationFrame(n), c = !1
      }), e(r, "scroll", function(t) {
        t.preventDefault(), r.scrollTop = r.scrollLeft = 0
      })
    }

    function ut(t) {
      var n, e = /Android/.test(navigator.userAgent) ? 3 : 2,
        r = t.options.delegateTo || t.containerEl,
        o = new V,
        i = R(t),
        u = 0;
      i(r, "touchstart", function(e) {
        o.track(e), t.setMomentum(0, 0), 0 === u && (n = t.options.damping, t.options.damping = Math.max(n, .5)), u++
      }), i(r, "touchmove", function(n) {
        if (!Z || Z === t) {
          o.update(n);
          var e = o.getDelta(),
            r = e.x,
            i = e.y;
          t.addTransformableMomentum(r, i, n, function(e) {
            e && (n.preventDefault(), Z = t)
          })
        }
      }), i(r, "touchcancel touchend", function(r) {
        var i = o.getVelocity(),
          c = {
            x: 0,
            y: 0
          };
        Object.keys(i).forEach(function(t) {
          var r = i[t] / n;
          c[t] = Math.abs(r) < 50 ? 0 : r * e
        }), t.addTransformableMomentum(c.x, c.y, r), 0 == --u && (t.options.damping = n), o.release(r), Z = null
      })
    }

    function ct(t) {
      R(t)(t.options.delegateTo || t.containerEl, "onwheel" in window || document.implementation.hasFeature("Events.wheel", "3.0") ? "wheel" : "mousewheel", function(n) {
        var e = function(t) {
            if ("deltaX" in t) {
              var n = ft(t.deltaMode);
              return {
                x: t.deltaX / st.STANDARD * n,
                y: t.deltaY / st.STANDARD * n
              }
            }
            return "wheelDeltaX" in t ? {
              x: t.wheelDeltaX / st.OTHERS,
              y: t.wheelDeltaY / st.OTHERS
            } : {
              x: 0,
              y: t.wheelDelta / st.OTHERS
            }
          }(n),
          r = e.x,
          o = e.y;
        t.addTransformableMomentum(r, o, n, function(t) {
          t && n.preventDefault()
        })
      })
    }! function(t) {
      t[t.TAB = 9] = "TAB", t[t.SPACE = 32] = "SPACE", t[t.PAGE_UP = 33] = "PAGE_UP", t[t.PAGE_DOWN = 34] = "PAGE_DOWN", t[t.END = 35] = "END", t[t.HOME = 36] = "HOME", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN"
    }(J || (J = {})),
    function(t) {
      t[t.X = 0] = "X", t[t.Y = 1] = "Y"
    }(Q || (Q = {}));
    var st = {
        STANDARD: 1,
        OTHERS: -3
      },
      at = [1, 28, 500],
      ft = function(t) {
        return at[t] || at[0]
      },
      lt = new Map,
      pt = function() {
        function t(t, n) {
          var e = this;
          this.offset = {
            x: 0,
            y: 0
          }, this.limit = {
            x: 1 / 0,
            y: 1 / 0
          }, this.bounding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }, this._plugins = [], this._momentum = {
            x: 0,
            y: 0
          }, this._listeners = new Set, this.containerEl = t;
          var r = this.contentEl = document.createElement("div");
          this.options = new N(n), t.setAttribute("data-scrollbar", "true"), t.setAttribute("tabindex", "-1"), B(t, {
            overflow: "hidden",
            outline: "none"
          }), window.navigator.msPointerEnabled && (t.style.msTouchAction = "none"), r.className = "scroll-content", Array.from(t.childNodes).forEach(function(t) {
            r.appendChild(t)
          }), t.appendChild(r), this.track = new q(this), this.size = this.getSize(), this._plugins = function(t, n) {
            return Array.from(nt.order).filter(function(t) {
              return !1 !== n[t]
            }).map(function(e) {
              var r = new(0, nt.constructors[e])(t, n[e]);
              return n[e] = r.options, r
            })
          }(this, this.options.plugins);
          var o = t.scrollLeft,
            i = t.scrollTop;
          t.scrollLeft = t.scrollTop = 0, this.setPosition(o, i, {
            withoutCallbacks: !0
          });
          var u = window,
            c = u.MutationObserver || u.WebKitMutationObserver || u.MozMutationObserver;
          "function" == typeof c && (this._observer = new c(function() {
            e.update()
          }), this._observer.observe(r, {
            subtree: !0,
            childList: !0
          })), lt.set(t, this), requestAnimationFrame(function() {
            e._init()
          })
        }
        return Object.defineProperty(t.prototype, "parent", {
          get: function() {
            for (var t = this.containerEl.parentElement; t;) {
              var n = lt.get(t);
              if (n) return n;
              t = t.parentElement
            }
            return null
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "scrollTop", {
          get: function() {
            return this.offset.y
          },
          set: function(t) {
            this.setPosition(this.scrollLeft, t)
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "scrollLeft", {
          get: function() {
            return this.offset.x
          },
          set: function(t) {
            this.setPosition(t, this.scrollTop)
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.getSize = function() {
          return n = (t = this).containerEl, e = t.contentEl, {
            container: {
              width: n.clientWidth,
              height: n.clientHeight
            },
            content: {
              width: e.offsetWidth - e.clientWidth + e.scrollWidth,
              height: e.offsetHeight - e.clientHeight + e.scrollHeight
            }
          };
          var t, n, e
        }, t.prototype.update = function() {
          var t, n, e, r, o;
          n = (t = this).getSize(), e = {
            x: Math.max(n.content.width - n.container.width, 0),
            y: Math.max(n.content.height - n.container.height, 0)
          }, r = t.containerEl.getBoundingClientRect(), o = {
            top: Math.max(r.top, 0),
            right: Math.min(r.right, window.innerWidth),
            bottom: Math.min(r.bottom, window.innerHeight),
            left: Math.max(r.left, 0)
          }, t.size = n, t.limit = e, t.bounding = o, t.track.update(), t.setPosition(), this._plugins.forEach(function(t) {
            t.onUpdate()
          })
        }, t.prototype.isVisible = function(t) {
          return function(t, n) {
            var e = t.bounding,
              r = n.getBoundingClientRect(),
              o = Math.max(e.top, r.top),
              i = Math.max(e.left, r.left),
              u = Math.min(e.right, r.right);
            return o < Math.min(e.bottom, r.bottom) && i < u
          }(this, t)
        }, t.prototype.setPosition = function(t, n, e) {
          var r = this;
          void 0 === t && (t = this.offset.x), void 0 === n && (n = this.offset.y), void 0 === e && (e = {});
          var o = function(t, n, e) {
            var r = t.options,
              o = t.offset,
              u = t.limit,
              c = t.track,
              s = t.contentEl;
            return r.renderByPixels && (n = Math.round(n), e = Math.round(e)), n = O(n, 0, u.x), e = O(e, 0, u.y), n !== o.x && c.xAxis.show(), e !== o.y && c.yAxis.show(), r.alwaysShowTracks || c.autoHideOnIdle(), n === o.x && e === o.y ? null : (o.x = n, o.y = e, B(s, {
              "-transform": "translate3d(" + -n + "px, " + -e + "px, 0)"
            }), c.update(), {
              offset: i({}, o),
              limit: i({}, u)
            })
          }(this, t, n);
          o && !e.withoutCallbacks && this._listeners.forEach(function(t) {
            t.call(r, o)
          })
        }, t.prototype.scrollTo = function(t, n, e, r) {
          void 0 === t && (t = this.offset.x), void 0 === n && (n = this.offset.y), void 0 === e && (e = 0), void 0 === r && (r = {}),
            function(t, n, e, r, o) {
              void 0 === r && (r = 0);
              var i = void 0 === o ? {} : o,
                u = i.easing,
                c = void 0 === u ? $ : u,
                s = i.callback,
                a = t.options,
                f = t.offset,
                l = t.limit;
              a.renderByPixels && (n = Math.round(n), e = Math.round(e));
              var p = f.x,
                h = f.y,
                d = O(n, 0, l.x) - p,
                v = O(e, 0, l.y) - h,
                y = Date.now();
              cancelAnimationFrame(K.get(t)),
                function n() {
                  var e = Date.now() - y,
                    o = r ? c(Math.min(e / r, 1)) : 1;
                  if (t.setPosition(p + d * o, h + v * o), e >= r) "function" == typeof s && s.call(t);
                  else {
                    var i = requestAnimationFrame(n);
                    K.set(t, i)
                  }
                }()
            }(this, t, n, e, r)
        }, t.prototype.scrollIntoView = function(t, n) {
          void 0 === n && (n = {}),
            function(t, n, e) {
              var r = void 0 === e ? {} : e,
                o = r.alignToTop,
                i = void 0 === o || o,
                u = r.onlyScrollIfNeeded,
                c = void 0 !== u && u,
                s = r.offsetTop,
                a = void 0 === s ? 0 : s,
                f = r.offsetLeft,
                l = void 0 === f ? 0 : f,
                p = r.offsetBottom,
                h = void 0 === p ? 0 : p,
                d = t.containerEl,
                v = t.bounding,
                y = t.offset,
                m = t.limit;
              if (n && d.contains(n)) {
                var g = n.getBoundingClientRect();
                if (!c || !t.isVisible(n)) {
                  var b = i ? g.top - v.top - a : g.bottom - v.bottom + h;
                  t.setMomentum(g.left - v.left - l, O(b, -y.y, m.y - y.y))
                }
              }
            }(this, t, n)
        }, t.prototype.addListener = function(t) {
          if ("function" != typeof t) throw new TypeError("[smooth-scrollbar] scrolling listener should be a function");
          this._listeners.add(t)
        }, t.prototype.removeListener = function(t) {
          this._listeners.delete(t)
        }, t.prototype.addTransformableMomentum = function(t, n, e, r) {
          this._updateDebounced();
          var o = this._plugins.reduce(function(t, n) {
              return n.transformDelta(t, e) || t
            }, {
              x: t,
              y: n
            }),
            i = !this._shouldPropagateMomentum(o.x, o.y);
          i && this.addMomentum(o.x, o.y), r && r.call(this, i)
        }, t.prototype.addMomentum = function(t, n) {
          this.setMomentum(this._momentum.x + t, this._momentum.y + n)
        }, t.prototype.setMomentum = function(t, n) {
          0 === this.limit.x && (t = 0), 0 === this.limit.y && (n = 0), this.options.renderByPixels && (t = Math.round(t), n = Math.round(n)), this._momentum.x = t, this._momentum.y = n
        }, t.prototype.updatePluginOptions = function(t, n) {
          this._plugins.forEach(function(e) {
            e.name === t && Object.assign(e.options, n)
          })
        }, t.prototype.destroy = function() {
          var t = this.containerEl,
            n = this.contentEl;
          ! function(t) {
            var n = z.get(t);
            n && (n.forEach(function(t) {
              var n = t.elem,
                e = t.eventName,
                r = t.handler;
              n.removeEventListener(e, r, C())
            }), z.delete(t))
          }(this), this._listeners.clear(), this.setMomentum(0, 0), cancelAnimationFrame(this._renderID), this._observer && this._observer.disconnect(), lt.delete(this.containerEl);
          for (var e = Array.from(n.childNodes); t.firstChild;) t.removeChild(t.firstChild);
          e.forEach(function(n) {
            t.appendChild(n)
          }), B(t, {
            overflow: ""
          }), t.scrollTop = this.scrollTop, t.scrollLeft = this.scrollLeft, this._plugins.forEach(function(t) {
            t.onDestory()
          }), this._plugins.length = 0
        }, t.prototype._init = function() {
          var t = this;
          this.update(), Object.keys(r).forEach(function(n) {
            r[n](t)
          }), this._plugins.forEach(function(t) {
            t.onInit()
          }), this._render()
        }, t.prototype._updateDebounced = function() {
          this.update()
        }, t.prototype._shouldPropagateMomentum = function(t, n) {
          void 0 === t && (t = 0), void 0 === n && (n = 0);
          var e = this.options,
            r = this.offset,
            o = this.limit;
          if (!e.continuousScrolling) return !1;
          0 === o.x && 0 === o.y && this._updateDebounced();
          var i = O(t + r.x, 0, o.x),
            u = O(n + r.y, 0, o.y),
            c = !0;
          return (c = (c = c && i === r.x) && u === r.y) && (r.x === o.x || 0 === r.x || r.y === o.y || 0 === r.y)
        }, t.prototype._render = function() {
          var t = this._momentum;
          if (t.x || t.y) {
            var n = this._nextTick("x"),
              e = this._nextTick("y");
            t.x = n.momentum, t.y = e.momentum, this.setPosition(n.position, e.position)
          }
          var r = i({}, this._momentum);
          this._plugins.forEach(function(t) {
            t.onRender(r)
          }), this._renderID = requestAnimationFrame(this._render.bind(this))
        }, t.prototype._nextTick = function(t) {
          var n = this.options,
            e = this.offset,
            r = this._momentum,
            o = e[t],
            i = r[t];
          if (Math.abs(i) <= .1) return {
            momentum: 0,
            position: o + i
          };
          var u = i * (1 - n.damping);
          return n.renderByPixels && (u |= 0), {
            momentum: u,
            position: o + i - u
          }
        }, u([D(100, {
          leading: !0
        })], t.prototype, "_updateDebounced", null), t
      }(),
      ht = "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: rgba(222, 222, 222, .75);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, .5);\n  border-radius: 4px;\n}\n",
      dt = "smooth-scrollbar-style",
      vt = !1;

    function yt() {
      if (!vt && "undefined" != typeof window) {
        var t = document.createElement("style");
        t.id = dt, t.textContent = ht, document.head && document.head.appendChild(t), vt = !0
      }
    }
    e.d(n, "ScrollbarPlugin", function() {
      return tt
    });
    /*!
     * cast `I.Scrollbar` to `Scrollbar` to avoid error
     *
     * `I.Scrollbar` is not assignable to `Scrollbar`:
     *     "privateProp" is missing in `I.Scrollbar`
     *
     * @see https://github.com/Microsoft/TypeScript/issues/2672
     */
    var mt = function(t) {
      function n() {
        return null !== t && t.apply(this, arguments) || this
      }
      return function(t, n) {
        function e() {
          this.constructor = t
        }
        o(t, n), t.prototype = null === n ? Object.create(n) : (e.prototype = n.prototype, new e)
      }(n, t), n.init = function(t, n) {
        if (!t || 1 !== t.nodeType) throw new TypeError("expect element to be DOM Element, but got " + t);
        return yt(), lt.has(t) ? lt.get(t) : new pt(t, n)
      }, n.initAll = function(t) {
        return Array.from(document.querySelectorAll("[data-scrollbar]"), function(e) {
          return n.init(e, t)
        })
      }, n.has = function(t) {
        return lt.has(t)
      }, n.get = function(t) {
        return lt.get(t)
      }, n.getAll = function() {
        return Array.from(lt.values())
      }, n.destroy = function(t) {
        var n = lt.get(t);
        n && n.destroy()
      }, n.destroyAll = function() {
        lt.forEach(function(t) {
          t.destroy()
        })
      }, n.use = function() {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        return function() {
          for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
          t.forEach(function(t) {
            var n = t.pluginName;
            if (!n) throw new TypeError("plugin name is required");
            nt.order.add(n), nt.constructors[n] = t
          })
        }.apply(void 0, t)
      }, n.attachStyle = function() {
        return yt()
      }, n.detachStyle = function() {
        return function() {
          if (vt && "undefined" != typeof window) {
            var t = document.getElementById(dt);
            t && t.parentNode && (t.parentNode.removeChild(t), vt = !1)
          }
        }()
      }, n.version = "8.4.0", n.ScrollbarPlugin = tt, n
    }(pt);
    n.default = mt
  }]).default
});